/** Cliente HTTP de la vista de Morosidad: lista completa de deudores +
 *  apertura de órdenes de corte en lote. */
import { apiRequest } from "../../lib/api";
import type { TopDeudor as TopDeudorDashboard } from "../dashboard/api";

/** Fila de Morosidad: la del dashboard + el vencimiento de la boleta impaga
 *  más antigua (de ahí sale el semáforo, igual que en la cuenta corriente). */
export interface TopDeudor extends TopDeudorDashboard {
  vencimiento_mas_antiguo?: string | null;
}

/** Todos los deudores del comité (no sólo el top 10 del dashboard). Sin
 *  tope: el backend devuelve la lista completa. */
export function listarDeudores(): Promise<TopDeudor[]> {
  return apiRequest<TopDeudor[]>("/api/v1/dashboard/deudores");
}

export interface AbrirLoteItem {
  contrato_id: number;
  monto_deuda_al_corte: number;
}

export interface AbrirLoteResultado {
  abiertas: number;
  omitidas: number;
  ordenes_ids: number[];
}

/** Abre órdenes de corte en lote. El backend saltea los que ya tienen una
 *  orden activa (los cuenta como omitidos). */
export function abrirCortesLote(
  items: AbrirLoteItem[],
): Promise<AbrirLoteResultado> {
  return apiRequest<AbrirLoteResultado>("/api/v1/ordenes-corte/lote", {
    method: "POST",
    body: { items },
  });
}
